import { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";

export default function TemporaryDrawer({ search, setSearch, menuClick, setMenuClick, menuKind, setMenuKind }) {
    const [showMenu, setShowMenu] = useState(false);

    const toggleDrawer = (event) => {
        setShowMenu(!showMenu);
    };

    const showSearchResult = (e) => {
        setMenuClick(true);
        setMenuKind(e.target.innerText);
        setSearch("");
    };

    return (
        <>
            <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={toggleDrawer}
                sx={{
                    "&:hover": {
                        cursor: "pointer",
                        boxSizing: "border-box",
                        fontWeight: "bold",
                        opacity: [0.9, 0.8, 0.7],
                    },
                }}
            >
                <MenuIcon
                    sx={{
                        "&:hover": {
                            cursor: "pointer",
                            boxSizing: "border-box",
                            fontWeight: "bold",
                            opacity: [0.9, 0.8, 0.7],
                        },
                    }}
                    fontSize="large"
                />
            </IconButton>
            <Drawer open={showMenu} onClose={toggleDrawer}>
                <Box role="presentation" onClick={toggleDrawer} onKeyDown={toggleDrawer}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={showSearchResult}>
                                {/* search뒤에다가 쿼리스트링 붙여주기 ex.?query=series 그 쿼리스트링을 searchResult페이지에서 searchParams로 읽은다음 관련 결과 띄워주기 */}
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                "&:hover": {
                                                    cursor: "pointer",
                                                    boxSizing: "border-box",
                                                    fontWeight: "bold",
                                                    opacity: [0.9, 0.8, 0.7],
                                                },
                                            }}
                                        >
                                            Most Downloaded
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={showSearchResult}>
                                {/* search뒤에다가 쿼리스트링 붙여주기 ex.?query=series 그 쿼리스트링을 searchResult페이지에서 searchParams로 읽은다음 관련 결과 띄워주기 */}
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                "&:hover": {
                                                    cursor: "pointer",
                                                    boxSizing: "border-box",
                                                    fontWeight: "bold",
                                                    opacity: [0.9, 0.8, 0.7],
                                                },
                                            }}
                                        >
                                            Most Liked
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={showSearchResult}>
                                {/* search뒤에다가 쿼리스트링 붙여주기 ex.?query=series 그 쿼리스트링을 searchResult페이지에서 searchParams로 읽은다음 관련 결과 띄워주기 */}
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                "&:hover": {
                                                    cursor: "pointer",
                                                    boxSizing: "border-box",
                                                    fontWeight: "bold",
                                                    opacity: [0.9, 0.8, 0.7],
                                                },
                                            }}
                                        >
                                            Recently Added
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={showSearchResult}>
                                {/* search뒤에다가 쿼리스트링 붙여주기 ex.?query=series 그 쿼리스트링을 searchResult페이지에서 searchParams로 읽은다음 관련 결과 띄워주기 */}
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                "&:hover": {
                                                    cursor: "pointer",
                                                    boxSizing: "border-box",
                                                    fontWeight: "bold",
                                                    opacity: [0.9, 0.8, 0.7],
                                                },
                                            }}
                                        >
                                            Favorites
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    );
}
